import { ProjectSource, UserRegistrationPeriod } from '../api/generated/data-contracts';
export default class TimePeriodGroupM {
    constructor(
        public GroupId: string,
        public GroupName: string,
        public ProjectSource: ProjectSource,
        public TimeRows: UserRegistrationPeriod[],
        public Expanded: boolean,
    ) {}
}
